<!--  ############### Top Select Month Start ################# -->
<div class="select_month_section">
	<section class="row align-items-center">
		<div class="select_month col-auto">
			<label class="col-form-label">{{"SELECTMONTH" | translate}}:</label>
            <select 
            class="form-select" 
            aria-label="Month selection"
            [(ngModel)]="selectedDate"
            (change)="onSearch()">
                <option *ngFor="let date of monthDropdown" [value]="date.dayDate">
                    <!-- {{ "DDMONTH."+getMonth(date) | translate}} {{getYear(date)}} -->
                    {{(lang == 'en') ? date.eNdate: date.jPdate}}
                </option>
            </select>
		</div>
		<div class="col" *ngIf="displayByCompany && associatesList && associatesList.length > 0">
			<label class="col-form-label text-start d-block" style="white-space: normal; overflow: visible; font-weight: bold; color: #385f96; font-size: calc(1rem - 1px);">{{selectedCompanyName}} - {{selectedSectionName}}</label>
		</div>
		<!-- <div class="col-auto co_name">
			<h2>{{"CompanyName" | translate}}:</h2>
			<p>{{userName}}</p>
		</div>
		<div class="summary col-auto gap-2">
			<div class="download_dropdown">
				<a href="download-attendance-summary/{{timeSheetDate}}"><button class="btn btn-primary btn-sm"><i class="bi bi-download"></i> {{"Home.Download" | translate}}</button></a>
				<ul>
					<li><a href="download-attendance-summary">{{"Home.DwnMainMenu" | translate}}</a> </li>
					<li><a href="download-contract-details">{{"Home.DwnContractList" | translate}}</a> </li>
				</ul>
			</div>
			
			
		</div> -->
		</section>
</div>
<!--  ############### Top Select Month End ################# -->
<!--  ############### Middle Containt Area Start ################# -->
<div class="container_wrapper">

	<!-- <div class="filter_options mb-3">
		<div class="row align-items-center">
			<div><h3>{{"Filters" | translate}}</h3></div>
			<div class="float_end"><span class="result_count">{{"ResultCnt" | translate}}: {{totalCount}}</span></div>
		</div>
		
		<div class="row align-items-end">
			<div class="mb-3">
				<label class="col-form-label">Supplier department:</label>
				<select 
                class="form-select" 
                [(ngModel)]="selectedBranch"
                aria-label="Month selection">
                    <option value="-1"> All</option>
                    <option *ngFor="let branch of branchDropdown" [value]="branch.branchId">
                        {{branch.branchName}}
                    </option>
                </select>
			</div>
			<div class="mb-3">
				<label class="col-form-label">{{"Company" | translate}}:</label>
				<select 
                class="form-select" 
                [(ngModel)]="selectedCustomer"
                aria-label="Month selection">
                    <option value="-1"> {{"All" | translate}}</option>
                    <option *ngFor="let customer of customerDropdown" [value]="customer.customerID">
                        {{customer.customerName}}
                    </option>
                </select>
			</div>
			<div class="mb-3">
				<label class="col-form-label">{{"SelectService" | translate}}:</label>
				<select class="form-select" id="" name="" [(ngModel)]="selectedService">
					<option value="-1" selected>{{"All" | translate}}</option>
				</select>
			</div>
			<div class="mb-3">
				<label class="col-form-label">{{"SELECTMONTH" | translate}}:</label>
				<select 
                class="form-select" 
                aria-label="Month selection"
                [(ngModel)]="selectedDate">
                    <option *ngFor="let date of monthDropdown" [value]="date.dayDate">
                        {{ "DDMONTH."+getMonth(date) | translate}} {{getYear(date)}}
                          {{(lang == 'en') ? date.eNdate: date.jPdate}}
                    </option>
                </select>
			</div>
			
			<div class="mb-3">
				<button type="button" class="btn btn-primary" (click)="onSearch()">{{"Search" | translate}}</button>
				<button type="button" class="btn btn-primary" (click)="clearAll()">{{"ClearAll" | translate}}</button>
			</div>
		</div>
	</div> -->
	
	<!--  ############### Data Table Start ################# -->
	<div class="client_associate_list p_table">

		<!-- データなしメッセージ（当月データなし、かつ会社別表示でない場合） -->
		<div class="empty_message" *ngIf="!isLoading && !displayByCompany && companiesList.length === 0">
			<p>{{'NoListFound' | translate}}</p>
		</div>

        <p-table 
        *ngIf="!displayByCompany && companiesList.length > 0"
        id="tbl_company"
        #dt1
        [value]="filteredCompaniesList" [tableStyle]="{'width':'100%'}" 
        [paginator]="true"
        [rows]="20"
        [showCurrentPageReport]="true"
        [globalFilterFields]="['comSearchText']"
        [lazy]="enableServerPaginationCompanies"
        [totalRecords]="enableServerPaginationCompanies ? totalRecords : filteredCompaniesList.length"
        currentPageReportTemplate="{{'Showing' |translate}} {first} {{'to' | translate}} {last} {{'of' | translate}} {totalRecords} {{'entries' | translate}}"
        (onFilter)="onFilter($event)"
        (onPage)="onPage($event)">
        <!-- (onSort)="onSort()" -->
        <!-- <table class="display nowrap table table-striped" style="width:100%"> -->
            <ng-template #caption>
                
                    <p-iconfield iconPosition="left" class="ml-auto">                        
                        <label>{{"SearchByText" | translate}}:</label>
                        <input pInputText type="text" (input)="applyFilterGlobal($event)" placeholder="{{'SearchKey' | translate}}" />
                    </p-iconfield>
                
            </ng-template>
            <ng-template pTemplate="colgroup">
                <colgroup>
                    <col style="width: 290px;"><!-- 会社名 -->
                    <col style="width: 170px;"><!-- 部署名 -->
                    <col style="width: 50px;"><!-- REGULAR -->
                    <col style="width: 50px;"><!-- OVERTIME -->
                    <col style="width: 47px;"><!-- MIDNIGHT -->
                    <col style="width: 50px;"><!-- TOTAL -->
                    <col style="width: 40px;"><!-- NOTSUBMIT -->
                    <col style="width: 40px;"><!-- SUBMIT -->
                    <col style="width: 40px;"><!-- REJECT -->
                    <col style="width: 40px;"><!-- APPROVE -->
                    <col style="width: 36px;"><!-- HOME -->
                    <col style="width: 36px;"><!-- ABSENCE -->
                    <col style="width: 36px;"><!-- PAID HOLIDAY -->
                    <col style="width: 70px;"><!-- Staff/Contracts -->
                </colgroup>
            </ng-template>
            <ng-template pTemplate="header">                
                <!-- <thead> -->
                    <tr class="tbl_head">
                        <th rowspan="2" class="bor_lft_none">{{"AssociatesList.Company" | translate}}</th>
                        <th rowspan="2">
                          <span class="pc-only">{{"AssociatesList.Section" | translate}}</span>
                          <span class="mobile-only">{{"AssociatesList.Company" | translate}} / {{"AssociatesList.Section" | translate}}</span>
                        </th>
                        <th colspan="4">{{"AssociatesList.TWH" | translate}}</th>
                        <th colspan="4">{{"AssociatesList.STATUS" | translate}}</th>
                        <th colspan="3">{{"AssociatesList.Summary" | translate}}</th>
                        <th rowspan="2" class="min-desktop">{{"ResourceNum" | translate}}/{{"ContractNum" | translate}}</th>
                        <!-- {{"AssociatesList.ContractTerm" | translate}} -->
                    </tr>
                    <tr class="tbl_head">
                        <!-- <th pSortableColumn="code" style="width:20%">
                            <div class="flex items-center gap-2">
                                {{"AssociatesList.REGULAR" | translate}}
                                <p-sortIcon field="code" />
                            </div>
                        </th> -->
                        <th>{{"AssociatesList.REGULAR" | translate}}</th>
                        <th>{{"AssociatesList.OVERTIME" | translate}}</th>
                        <th>{{"AssociatesList.MIDNIGHT" | translate}}</th>
                        <th>{{"AssociatesList.TOTAL" | translate}}</th>
                        <th>{{"SHORTSTATUS.NOTSUBMIT" | translate}}</th>
                        <th>{{"SHORTSTATUS.SUBMIT" | translate}}</th>
                        <th>{{"SHORTSTATUS.REJECT" | translate}}</th>
                        <th>{{"SHORTSTATUS.APPROVE" | translate}}</th>
                        <th>{{"AssociatesList.home" | translate}}</th>
                        <th>{{"AssociatesList.Absence" | translate}}</th>
                        <th>{{"AssociatesList.PaidHoliday" | translate}}</th>
                        <!-- <th>{{"AssociatesList.ContractTerm" | translate}}</th> -->
                    </tr>
                <!-- </thead>     -->
            </ng-template>
            <ng-template pTemplate="body" let-item>
                <!-- <tr class="tbl_cont">
                    <td [attr.rowspan]="item.timesheetSummaryCompanySectionGroupDto.length"><a href="javascript:void(0)" class="dlt_link" (click)="onCmpSearch(item.customerID)">{{item.customerName}}</a></td>
                    <td>{{item.timesheetSummaryCompanySectionGroupDto[0].section}}</td>
                    <td>{{item.timesheetSummaryCompanySectionGroupDto[0].regular}}</td>
                    <td>{{item.timesheetSummaryCompanySectionGroupDto[0].overtime}}</td>
                    <td>{{item.timesheetSummaryCompanySectionGroupDto[0].midnightOvertime}}</td>
                    <td>{{item.timesheetSummaryCompanySectionGroupDto[0].total}}</td>
                    <td>{{item.timesheetSummaryCompanySectionGroupDto[0].notSubmit}}</td>
                    <td>{{item.timesheetSummaryCompanySectionGroupDto[0].submit}}</td>
                    <td>{{item.timesheetSummaryCompanySectionGroupDto[0].reject}}</td>
                    <td>{{item.timesheetSummaryCompanySectionGroupDto[0].approve}}</td>
                    <td>{{item.timesheetSummaryCompanySectionGroupDto[0].teleWork}}</td>
                    <td>{{item.timesheetSummaryCompanySectionGroupDto[0].absence}}</td>
                    <td>{{item.timesheetSummaryCompanySectionGroupDto[0].paidHoliday}}</td>
                    <td>{{item.timesheetSummaryCompanySectionGroupDto[0].userCount}}/{{item.timesheetSummaryCompanySectionGroupDto[0].contractCount}}</td>
                </tr>
                
                <tr class="tbl_cont" *ngFor="let subItem of item.timesheetSummaryCompanySectionGroupDto.slice(1)">                    
                    <td>{{subItem.section}} </td>
                    <td>{{subItem.regular}}</td>
                    <td>{{subItem.overtime}}</td>
                    <td>{{subItem.midnightOvertime}}</td>
                    <td>{{subItem.total}}</td>
                    <td>{{subItem.notSubmit}}</td>
                    <td>{{subItem.submit}}</td>
                    <td>{{subItem.reject}}</td>
                    <td>{{subItem.approve}}</td>
                    <td>{{subItem.teleWork}}</td>
                    <td>{{subItem.absence}}</td>
                    <td>{{subItem.paidHoliday}}</td>
                    <td>{{subItem.userCount}}/{{subItem.contractCount}}</td>
                </tr> -->
                <tr class="tbl_cont">                    
                    <td>{{item.customerName}}</td>
                    <td class="col-text-left">
                      <a href="javascript:void(0)" class="dlt_link pc-only" (click)="onCmpSearch(item.customerId, item.sectionId)">{{item.section}}</a>
                      <a href="javascript:void(0)" class="dlt_link mobile-only" (click)="onCmpSearch(item.customerId, item.sectionId)">{{item.customerName}} / {{item.section}}</a>
                    </td>
                    <td>{{item.regular}}</td>
                    <td>{{item.overtime}}</td>
                    <td>{{item.midnightOvertime}}</td>
                    <td>{{item.total}}</td>
                    <td>{{item.notSubmit}}</td>
                    <td>{{item.submit}}</td>
                    <td>{{item.reject}}</td>
                    <td>{{item.approve}}</td>
                    <td>{{item.teleWork}}</td>
                    <td>{{item.absence}}</td>
                    <td>{{item.paidHoliday}}</td>
                    <td class="col-text-center">{{item.userCount}}/{{item.contractCount}}</td>
                </tr>
            </ng-template>
            <ng-template pTemplate="footer">
                <tr class="tbl_fot">
                    <td colspan="2">{{"TOTAL" | translate}}</td>
                    <td>{{ totalRegular }}</td>  <!-- Regular total -->
                    <td>{{ totalOverTime }}</td>  <!-- Overtime total -->
                    <td>{{ totalMn }}</td>  <!-- Midnight total -->
                    <td>{{ overAllTotal }}</td>  <!-- Overall total -->
                    <td>{{ totalNotSubmit }}</td>  <!-- Not Submit -->
                    <td>{{totalSubmit}}</td>  <!-- Submit -->
                    <td>{{totalReject}}</td>  <!-- Reject -->
                    <td>{{totalApprove}}</td>  <!-- Approve -->
                    <td>{{totalHome}}</td>  <!-- Home -->
                    <td>{{totalAbsence}}</td>  <!-- Absence -->
                    <td>{{totalPh}}</td>  <!-- Paid Holiday -->
                    <td>{{totalResource}}/{{totalContract}}</td>
                </tr>
            </ng-template>
            
        </p-table>
         <!--  -->
        <p-table 
        id="tbl_section"
        #dt2
        [value]="filteredAssociatesList" [tableStyle]="{'width':'100%'}" 
        [paginator]="true"
        [rows]="20"
        [showCurrentPageReport]="true"
        [globalFilterFields]="['searchText']"
        [lazy]="false"
        currentPageReportTemplate="{{'Showing' |translate}} {first} {{'to' | translate}} {last} {{'of' | translate}} {totalRecords} {{'entries' | translate}}"
        (onFilter)="onFilter($event)"
        (onPage)="onPage($event)" *ngIf="displayByCompany">
        <!-- <table class="display nowrap table table-striped" style="width:100%"> -->
            <ng-template #caption>
                <div style="display: flex; align-items: center; gap: 8px; flex-wrap: wrap;">
                    <p-iconfield iconPosition="left">                        
                        <label>{{"SearchByText" | translate}}:</label>
                        <input pInputText type="text" (input)="onGlobalFilter($event)" placeholder="{{'SearchKey' | translate}}" />
                    </p-iconfield>
                    <div class="actio_button_area" style="padding: 0; margin-left: auto;">
                        <a class="butn go_back btn" href="javascript:void(0)" (click)="goBack()">{{'Back' | translate}}</a>
                    </div>
                </div>
            </ng-template>
            <ng-template pTemplate="colgroup">
                <colgroup>
                    <col style="width: 337px;"><!-- 名前 -->
                    <col style="width: 70px;"><!-- REGULAR -->
                    <col style="width: 70px;"><!-- OVERTIME -->
                    <col style="width: 70px;"><!-- MIDNIGHT -->
                    <col style="width: 70px;"><!-- TOTAL -->
                    <col style="width: 50px;"><!-- NOTSUBMIT -->
                    <col style="width: 50px;"><!-- SUBMIT -->
                    <col style="width: 50px;"><!-- REJECT -->
                    <col style="width: 50px;"><!-- APPROVE -->
                    <col style="width: 46px;"><!-- HOME -->
                    <col style="width: 46px;"><!-- ABSENCE -->
                    <col style="width: 46px;"><!-- PAID HOLIDAY -->
                    <col style="width: 120px;"><!-- ContractTerm -->
                    <col style="width: 60px;"><!-- Download Summary -->
                    <col style="width: 60px;"><!-- Download Contract -->
                </colgroup>
            </ng-template>
            <ng-template pTemplate="header">                
                <!-- <thead> -->
                    <tr class="tbl_head">
                        <th rowspan="2" class="bor_lft_none">{{"AssociatesList.Name" | translate}}</th>
                        <th colspan="4">{{"AssociatesList.TWH" | translate}}</th>
                        <th colspan="4">{{"AssociatesList.STATUS" | translate}}</th>
                        <th colspan="3">{{"AssociatesList.Summary" | translate}}</th>
                        <th rowspan="2" class="min-desktop">{{"AssociatesList.ContractTerm" | translate}}</th>
                        <th colspan="2" class="min-desktop">{{"Download" | translate}}</th>
                    </tr>
                    <tr class="tbl_head">                        
                        <th>{{"AssociatesList.REGULAR" | translate}}</th>
                        <th>{{"AssociatesList.OVERTIME" | translate}}</th>
                        <th>{{"AssociatesList.MIDNIGHT" | translate}}</th>
                        <th>{{"AssociatesList.TOTAL" | translate}}</th>
                        <th>{{"AssociatesList.NOTSUBMIT" | translate}}</th>
                        <th>{{"AssociatesList.SUBMIT" | translate}}</th>
                        <th>{{"AssociatesList.REJECT" | translate}}</th>
                        <th>{{"AssociatesList.APPROVE" | translate}}</th>
                        <th>{{"AssociatesList.home" | translate}}</th>
                        <th>{{"AssociatesList.Absence" | translate}}</th>
                        <th>{{"AssociatesList.PaidHoliday" | translate}}</th>
                        <th class="min-desktop">{{"Home.DwnMainMenu" | translate}}</th>
                        <th class="min-desktop">{{"Home.DwnContractList" | translate}}</th>
                    </tr>
                <!-- </thead>     -->
            </ng-template>
            <ng-template pTemplate="body" let-item>
                <tr class="tbl_cont">
                    <td><a href="javascript:void(0)" class="dlt_link" (click)="navigateToTimesheet(item.timesheetId, item.userid)">{{item.userCode}} {{item.section}}</a></td>
                    <td>{{item.regular}}</td>
                    <td>{{item.overtime}}</td>
                    <td>{{item.midnightOvertime}}</td>
                    <td>{{item.total}}</td>
                    <td>{{item.notSubmit}}</td>
                    <td>{{item.submit}}</td>
                    <td>{{item.reject}}</td>
                    <td>{{item.approve}}</td>
                    <td>{{item.teleWork}}</td>
                    <td>{{item.absence}}</td>
                    <td>{{item.paidHoliday}}</td>
                    <td>{{item.contractTerm}}</td>
                    <td>
                        <button class="btn btn-primary btn-sm" (click)="createSingleAll(item.userIdOrg, item.userCode)"><i class="bi bi-download"></i></button>
                    </td>
                    <td>
                        <button class="btn btn-primary btn-sm" (click)="downloadContract(item.userIdOrg, item.userCode)"><i class="bi bi-download"></i></button>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="footer">
                <tr class="tbl_fot">
                    <td>{{"TOTAL" | translate}}</td>
                    <td>{{ totalRegularSection }}</td>  <!-- Regular total -->
                    <td>{{ totalOverTimeSection }}</td>  <!-- Overtime total -->
                    <td>{{ totalMnSection }}</td>  <!-- Midnight total -->
                    <td>{{ overAllTotalSection }}</td>  <!-- Overall total -->
                    <td>{{ totalNotSubmitSection }}</td>  <!-- Not Submit -->
                    <td>{{totalSubmitSection}}</td>  <!-- Submit -->
                    <td>{{totalRejectSection}}</td>  <!-- Reject -->
                    <td>{{totalApproveSection}}</td>  <!-- Approve -->
                    <td>{{totalHomeSection}}</td>  <!-- Home -->
                    <td>{{totalAbsenceSection}}</td>  <!-- Absence -->
                    <td>{{totalPhSection}}</td>  <!-- Paid Holiday -->
                    <td>&nbsp;</td>
                    <td><button class="btn btn-primary btn-sm" style="font-size: 0.7rem;" (click)="createSingleAll('-1', 'All')"><i class="bi bi-box-arrow-in-down"></i> {{"All" | translate}}</button></td>
                    <td><button class="btn btn-primary btn-sm" style="font-size: 0.7rem;" (click)="downloadContract('-1', 'All')"><i class="bi bi-box-arrow-in-down"></i> {{"All" | translate}}</button></td>
                </tr>
            </ng-template>
            <ng-template pTemplate="paginatorleft">
                <span class="pc-only" style="padding-right: 16px; font-size: 0.8rem; color: #555;">
                    <ng-container *ngIf="lang === 'jp'">※「全て」ボタンは、ページに関係なく全スタッフのデータを出力します。</ng-container>
                    <ng-container *ngIf="lang !== 'jp'">* The "All" button outputs data for all staff, regardless of pages.</ng-container>
                </span>
            </ng-template>
        </p-table>
	
	<!--  ############### Data Table End ################# -->
	
</div>
<!--  ############### Middle Containt Area End ################# -->
